import React, { Suspense } from "react";
import styles from "./PreLogin.module.scss";
// import Prelogin from "./../../assets/Images/prelogin-background.svg";
import { Outlet } from "react-router-dom";
import Prelogin from "./../../assets/Images/PreLogin.png";
import Login from "./../../assets/Images/Login.png";
import Loader from "components/loader/Loader";

const PreLogin = ({ children }) => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.leftSide}>
        {/* <span className={styles.heading}>
          Hello,
          <span>Welcome!!</span>
        </span> */}
          <img src={Login} className={styles.responsive} alt="Login" />
          <p className={styles.heading}>
            Access your dashboard, manage <br/>tasks, track progress, and <br/>collaborate—all in one place.
          </p>
      </div>
      <span className={styles.rightSide}>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </span>
    </div>
  );
};

export default PreLogin;
